import React, { useState, useRef, useEffect } from 'react';
import { ReactComponent as Collapse } from '../assets/collapse.svg';
import { FormattedMessage } from 'react-intl';

interface ManageButtonProps {
  optionList: ManageButtonDropdownOptions[];
  shouldShowSpinner: boolean;
  showDropdownOnTop: boolean | null;
  buttonLabelId?: string;
}

interface ManageButtonDropdownOptions {
  header: string;
  buttons: ManageButtonOption[];
}

interface ManageButtonOption {
  title: string;
  buttonName: string;
  onClick: (action: string) => void;
}

const ManageButton: React.FC<ManageButtonProps> = ({
  optionList,
  shouldShowSpinner,
  showDropdownOnTop,
  buttonLabelId,
}) => {
  const [dropDownVisibility, setDropDownVisibility] = useState(false);
  const nodeRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (e: MouseEvent) => {
    if (nodeRef.current && !nodeRef.current.contains(e.target as Node)) {
      setDropDownVisibility(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside, false);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside, false);
    };
  }, []);

  const handleButtonClick = () => {
    setDropDownVisibility((prevState) => !prevState);
  };

  const buttonText = (
    <div className="manage-button-div">
      <FormattedMessage id={buttonLabelId || 'manage-button-text'} />
      {shouldShowSpinner && <div className="spinner-manage" />}
    </div>
  );

  let manageButtonCss = 'manage-dropdown-content left-0';
  if (showDropdownOnTop) {
    manageButtonCss += ' manage-dropdown-content-on-top';
  }

  const dropdownContent = optionList.map((item, idx) => (
    <div key={idx}>
      {item.header && (
        <div className="manage-button-header-container">
          <div className="manage-button-header">{item.header}</div>
          <div className="manage-button-divider" />
        </div>
      )}
      {item.buttons.map((button, index) => (
        <div key={index}>
          <div
            className="dropdown-menu-item"
            onClick={() => {
              handleButtonClick();
              button.onClick(button.buttonName);
            }}
          >
            {button.title}
          </div>
        </div>
      ))}
    </div>
  ));

  return (
    <div className="dropdown" ref={nodeRef}>
      <button
        className="button button-secondary order-details-button manage-button-div"
        onClick={handleButtonClick}
      >
        {buttonText}
        <Collapse className="order-details-dropdown-collapse" />
      </button>
      {dropDownVisibility && (
        <div className={manageButtonCss}>{dropdownContent}</div>
      )}
    </div>
  );
};

export default ManageButton;
